import { createSelector } from '@reduxjs/toolkit';

import { getCompanyName, getCompanyNameObj } from '_helpers/order';
import { createOrderOptions } from '_helpers/orders';

export const selectData = (state) => state.orders.data;
export const selectError = (state) => state.orders.error;
export const selectLoading = (state) => state.orders.loading;

export const selectOrderOptions = createSelector([selectData], (data) => {
  return createOrderOptions(data);
});

export const selectOrderByProductId = (productId) =>
  createSelector([selectData], (data) => {
    return data.find((order) => {
      const { products } = order;
      return products?.some(({ id }) => id === productId);
    });
  });

export const selectCompanyNameByProductId = (productId) =>
  createSelector([selectOrderByProductId(productId)], (data) => getCompanyName(data));

export const selectCompanyNamesMap = createSelector([selectData], (data) => {
  return data?.reduce((res, order) => {
    const companyNameObj = getCompanyNameObj(order);
    return { ...res, ...companyNameObj };
  }, {});
});
